import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { useCustomerClient } from '@/lib/api'
import { DeviceMobile, Palette } from '@phosphor-icons/react'

export default function CustomersPage() {
  const navigate = useNavigate()
  const customerClient = useCustomerClient()

  const { data, isLoading, error } = useQuery({
    queryKey: ['customers'],
    queryFn: async () => {
      const response = await customerClient.getAll.query()
      return response.status === 200 ? response.body : []
    },
  })

  if (isLoading) return <div className="p-6">Loading customers...</div>
  if (error)
    return <div className="p-6 text-red-600">Failed to load customers</div>

  const customers = data || []

  return (
    <div className="py-6 px-6">
      <div className="max-w-[1280px]">
        <h1 className="text-xl font-bold leading-none mb-0">Gift Portals</h1>
        <p className="text-base leading-6 text-muted-foreground">
          Manage your customers and theming
        </p>
      </div>

      <div className="mt-6 max-w-[1280px] border border-base-input rounded-lg overflow-hidden">
        <table className="w-full text-left">
          <thead>
            <tr className="border-b border-base-input">
              <th className="h-10 px-2 text-sm font-medium leading-5 text-muted-foreground">
                Client
              </th>
              <th className="h-10 px-2" />
            </tr>
          </thead>
          <tbody>
            {customers.map((customer) => (
              <tr
                key={customer.id}
                className="border-b border-base-input last:border-b-0"
              >
                <td className="px-2 py-4 text-sm leading-5 text-foreground">
                  {customer.name}
                </td>
                <td className="px-2 py-4 text-right">
                  <button
                    type="button"
                    onClick={() =>
                      navigate(`/admin/customers/${customer.id}/theme`)
                    }
                    className="inline-flex items-center gap-2 h-8 px-3 py-2 bg-white border border-base-input rounded-full text-xs font-medium leading-4 text-foreground shadow-xs cursor-pointer hover:bg-gray-800/5"
                  >
                    <Palette weight="regular" className="w-4 h-4 shrink-0" />
                    Edit Theme
                  </button>
                  <button
                    type="button"
                    onClick={() =>
                      navigate(`/admin/customers/${customer.id}/end-user-theme`)
                    }
                    className="inline-flex items-center gap-2 h-8 px-3 py-2 ml-2 bg-white border border-base-input rounded-full text-xs font-medium leading-4 text-foreground shadow-xs cursor-pointer hover:bg-gray-800/5"
                  >
                    <DeviceMobile
                      weight="regular"
                      className="w-4 h-4 shrink-0"
                    />
                    Edit end-user theme
                  </button>
                </td>
              </tr>
            ))}
            {customers.length === 0 && (
              <tr>
                <td
                  colSpan={2}
                  className="px-2 py-8 text-center text-muted-foreground"
                >
                  No customers found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
